import { useQuery } from '@tanstack/react-query'
import { authService, dataSource } from '../../service/domain/_service.config'

export const USER_QUERY_KEY = ['user']

export function useUser() {
  return useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: async () => {
      const authID = await authService.getCurrentUserAuthID()
      if (!authID) return null
      return dataSource.getUserByAuthID(authID)
    },
    retry: false,
    // Ensure fresh data is fetched on mount to avoid stale cache issues
    // This is especially important for older accounts that might have outdated cached data
    staleTime: 0, // Data is immediately stale, will refetch on mount
    refetchOnMount: true, // Always refetch when component mounts
    refetchOnWindowFocus: true, // Refetch when app comes back into focus
  })
}
